import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
import { Tooltip } from "@mui/material";

interface Props {
  error: string;
}

const GridCellValidationError = ({ error }: Props) => {
  return (
    <Tooltip title={error}>
      <ErrorIcon color="error" />
    </Tooltip>
  );
};

export default GridCellValidationError;
